import styled, { css } from 'styled-components';
import { CommonTextInputStyles } from '../Textbox/Textbox.styles';
export const CommonTextareaStyles = css `
  ${CommonTextInputStyles};
  --borderRadius: 18px;
  height: auto;
  min-height: 100px;
`;
const Input = styled.textarea `
  ${CommonTextareaStyles};
  
`;
const TextareaStyles = {
    Input,
};
export default TextareaStyles;
